import Icon from '../components/Icon.vue'

Icon.register({
  'user-nurse': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M57.8 288c-8.8 0-16-7.2-16-16 0-2.1 0.8-5.3 1.7-7.2 15.2-29.8 31.3-62.2 42.2-95.5 7.6-23.2 10.3-47.7 10.3-72.1v-49.2l128-48 128 48v49.2c0 24.4 2.8 48.9 10.3 72.1 10.9 33.3 26.9 65.7 42.2 95.5 0.9 1.9 1.7 5.1 1.7 7.2 0 8.8-7.2 16-16 16h-82.4c-22.5 19.7-51.6 32-83.9 32s-61.3-12.3-83.9-32h-82.4zM184 71.7v16.7c0 2.8 2.2 5 5 5h21.7v21.7c0 2.8 2.2 5 5 5h16.7c2.8 0 5-2.2 5-5v-21.7h21.7c2.8 0 5-2.2 5-5v-16.7c0-2.8-2.2-5-5-5h-21.7v-21.7c0-2.8-2.2-5-5-5h-16.7c-2.8 0-5 2.2-5 5v21.7h-21.7c-2.8 0-5 2.2-5 5zM144 160v32c0 44.2 35.8 80 80 80s80-35.8 80-80v-32h-160zM319.4 320c71.5 3.1 128.6 61.6 128.6 133.8 0 32.1-26.1 58.2-58.2 58.2v0h-331.6c-32.1 0-58.2-26.1-58.2-58.2 0-72.2 57.1-130.7 128.6-133.8l95.4 95.4z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/user-nurse.js
// module id = 2069
// module chunks = 0